module.exports = __webpack_public_path__ + "img/brief-bg-mentor.b5f40b8e.png";